var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm.authorized ? _c(_setup.AuthorizedHeader, _vm._g(_vm._b({}, 'AuthorizedHeader', _vm.$attrs, false), _vm.$listeners)) : _c(_setup.UnauthorizedHeader, _vm._g(_vm._b({}, 'UnauthorizedHeader', _vm.$attrs, false), _vm.$listeners));
};
var staticRenderFns = [];
export { render, staticRenderFns };